import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

const LARGO = 500;
@Component({
    selector: "app-dialog-recibir",
    templateUrl: "./dialog-recibir.component.html",
    styleUrls: ["./dialog-recibir.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogRecibirComponent implements OnInit {
    formObservaciones: FormGroup;
    largoMaximo = LARGO;
    constructor(
        public dialogRef: MatDialogRef<DialogRecibirComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            idOOTT: number;
        },
        private _fb: FormBuilder
    ) {}

    ngOnInit(): void {
        //console.log(this.data.idOOTT);
        this.initForm();
    }

    initForm() {
        this.formObservaciones = this._fb.group({
            tieneObservaciones: [false],
            comentarios: [
                "",
                {
                    validators: [
                        Validators.minLength(1),
                        Validators.maxLength(LARGO),
                    ],
                },
            ],
        });
    }

    get tieneObservaciones() {
        return this.formObservaciones.get("tieneObservaciones");
    }
    get comentarios() {
        return this.formObservaciones.get("comentarios");
    }
}
